import { isStateScheduledOrLower } from "module/maintenanceTask/helper/isStateScheduledOrLower";
import { MaintenanceTaskInterface } from "module/maintenanceTask/types";

interface Props {
  isMaintenanceTaskOpen: boolean;
  canEditMaintenanceTask: boolean;
  maintenanceTask: MaintenanceTaskInterface;
}

export const canAddMaintenanceTaskInternalPersonnelAssignment = ({
  isMaintenanceTaskOpen,
  canEditMaintenanceTask,
  maintenanceTask,
}: Props): boolean =>
  isMaintenanceTaskOpen &&
  canEditMaintenanceTask &&
  isStateScheduledOrLower(maintenanceTask);
